/** @jsx h */
// @flow
import { h, VNode } from 'preact';
import ShadowContainer from '../../UiComponents/ShadowContainer';
import { useCheckoutContext } from '../../storeProviders/checkoutWidgetStore';
import FixedBottomContainer from '../../UiComponents/FixedBottomContainer';
import AmountButtonContainer from '../../UiComponents/AmountButtonContainer';
import type { CustomButtonProps } from '../../UiComponents/CustomButton';

type CheckoutContentProps = {
  children: VNode,
  buttonProps: CustomButtonProps,
  hasFooter: boolean,
  isMobileEditable: boolean,
  onEdit: () => void,
  autoHeight: boolean,
};

const CheckoutContentWrapper = (props: CheckoutContentProps) => {
  const checkoutState = useCheckoutContext();
  const { mobile } = checkoutState.eligibilityDetails || {};
  const { orderAmount } = checkoutState.orderDetails || {};
  const {
    children,
    hasFooter = false,
    buttonProps,
    isMobileEditable = false,
    onEdit,
    autoHeight,
  } = props || {};
  return (
    <ShadowContainer
      mobile={mobile}
      isMobileEditable={isMobileEditable}
      onEdit={onEdit}
      autoHeight={autoHeight}
      hasFooter={hasFooter}>
      {children}
      {hasFooter && (
        <FixedBottomContainer>
          <AmountButtonContainer
            buttonProps={props.buttonProps}
            amount={orderAmount}
          />
        </FixedBottomContainer>
      )}
    </ShadowContainer>
  );
};

export default CheckoutContentWrapper;



// WEBPACK FOOTER //
// ./components/checkoutWidget/CheckoutContentWrapper.js